import { colors } from "@src/constants"
import { usePartner } from "@src/partner"
import { useEffect } from "react"
import { Card } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { useParams } from "react-router-dom"

export const PermissionCard: React.FC = () => {
  const styles = { warningCard: { backgroundColor: colors.whiteGray } }
  const { t } = useTranslation()
  const { partnerUuid } = useParams()
  const { partner, changePartner } = usePartner()

  useEffect(() => {
    if (partner && partnerUuid && partner?.uuid !== partnerUuid) {
      changePartner(partnerUuid)
    }
  }, [partner])

  if (partner)
    return (
      <div className="d-flex justify-content-center align-items-center">
        <Card style={styles.warningCard} className="mt-4 p-2">
          {t("select_partner_screen.warning_role")}
        </Card>
      </div>
    )
}
